import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "setting-container" }
const _hoisted_2 = { class: "inner-content" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "box-style left-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "box-style right-container" }

import {ref,reactive,onMounted,onBeforeUnmount} from 'vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import Remote from './childPages/remote/index.vue' //遥控器设置页面
import Sensitivity from './childPages/sensitivity/index.vue' //灵敏度设置页面
import Sound from './childPages/sound/index.vue' //声音设置页面
import Shortcut from './childPages/shortcut/index.vue' //快捷键设置页面
import Viewsets from './childPages/viewsets/index.vue' //画面设置页面


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["onBack"],
  setup(__props, { emit: __emit }) {

const emit = __emit

/////////////////////////////////////////////   状态
const store = useStore()  
const router = useRouter()
const navList = ref([
  {name:'遥控器',icon:'vk_ykq_fill',index:0},
  {name:'灵敏度',icon:'vk_sd_fill',index:1},
  {name:'声音',icon:'setting_gg_fill',index:2},
  {name:'快捷键',icon:'setting_kjj_fill',index:3},
  {name:'画面',icon:'setting_dn_fill',index:4},
])
const activeIndex = ref(0)
/////////////////////////////////////////////   方法   
function handleBack(){
  // 触发关闭弹窗事件
  emit('onBack');
  // 如果不是通过弹窗方式打开的，则正常返回
  if (!window.listenEvent) {
    router.back();
  }
}

function handleClickNav(index:number){
  activeIndex.value = index
  window?.playClick()
}


return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass({'active':activeIndex.value == item.index}),
                onClick: ($event: any) => (handleClickNav(item.index))
              }, [
                _createVNode(_component_vkm_svg, {
                  "icon-name": item.icon,
                  class: "icon"
                }, null, 8, ["icon-name"]),
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ], 10, _hoisted_5))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (activeIndex.value == 0)
            ? (_openBlock(), _createBlock(Remote, { key: 0 }))
            : _createCommentVNode("", true),
          (activeIndex.value == 1)
            ? (_openBlock(), _createBlock(Sensitivity, { key: 1 }))
            : _createCommentVNode("", true),
          (activeIndex.value == 2)
            ? (_openBlock(), _createBlock(Sound, { key: 2 }))
            : _createCommentVNode("", true),
          (activeIndex.value == 3)
            ? (_openBlock(), _createBlock(Shortcut, { key: 3 }))
            : _createCommentVNode("", true),
          (activeIndex.value == 4)
            ? (_openBlock(), _createBlock(Viewsets, { key: 4 }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})